/**
 * FAQ's — exclusive accordion. When one <details> opens, close the others in
 * the same block. The first item ships `open` from PHP. Skipped in the
 * Gutenberg editor so it doesn't fight the static preview.
 */

function initBlock(root) {
  const items = Array.from(root.querySelectorAll(".bskr-faqs__item"));
  if (items.length < 2) return;

  items.forEach((item) => {
    item.addEventListener("toggle", () => {
      if (!item.open) return;
      items.forEach((other) => {
        if (other !== item) other.open = false;
      });
    });
  });
}

function init() {
  if (typeof window !== "undefined" && window.wp && window.wp.data) return;
  document.querySelectorAll(".wp-block-bskr-faqs").forEach(initBlock);
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", init);
} else {
  init();
}
